import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useAuth();
  const location = useLocation();


  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f0f7fc'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #e8f4fc',
          borderTopColor: '#0e73ba',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermission) {
    const perms = user.quyenHanhDong ? user.quyenHanhDong.split(',').map(s => s.trim()) : [];
    if (!perms.includes(String(requiredPermission))) {
      return <Navigate to="/trangchu" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
